import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {ImageStamp, Table} from "../../../components";
import {userLikesAction} from "redux/actions";

function LikesTab({clickedCustomer}) {
    const id = clickedCustomer.id

    // Redux
    const dispatch = useDispatch();

    const {customers, userLikes, userRole} = useSelector(state => ({
        customers: state.customers?.users,
        userLikes: state.userLikes,
        userRole: state.userRole?.filter(role => role.module === "Users")
    }));

    // States
    const [tableRows, setTableRows] = useState();

    // Fetch Package Add On
    useEffect(() => {
        const {mobile, countrycode} =
        customers?.find(user => user?.userId == id) || {};

        dispatch(userLikesAction.get({countryCode: countrycode, mobile}));

        return () => dispatch(userLikesAction.reset());
    }, [dispatch]);

    useEffect(() => {
        let filtered = userLikes;

        if (!filtered?.length) return;

        // Map table rows
        const data = filtered?.map(obj => ({
            id: obj?.id,
            packageName: obj?.packageName,
            packageImage: <ImageStamp src={obj.packageImage}/>,
            shortDescription: obj?.shortDescription,
            basePrice: obj?.basePrice,
            sellingPrice: obj?.sellingPrice,
            createdAt: `${new Date(obj?.createdAt).toLocaleString()}`,
            likedOn: `${new Date(obj?.likedOn).toLocaleString()}`
        }));

        setTableRows(data);
    }, [userLikes]);

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "ID"
            },
            {
                title: "Package Name",
                sortBy: "packageName"
            },
            {
                title: "Image"
            },
            {
                title: "Description"
            },
            {
                title: "Base Price"
            },
            {
                title: "Selling Price"
            },
            {
                title: "Created At"
            },
            {
                title: "Liked On",
                sortBy: "likedOn"
            }
        ],
        [tableRows]
    );

    return <Table headers={tableHeaders} data={tableRows}/>;
}

export default LikesTab;